var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "addRep",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "addRep-header"
        }, [_c('h4', [_vm._v("Add Rep User")])])];
      },
      proxy: true
    }])
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "addRep-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "addRepAdminContainer",
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.create);
            }
          }
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true,
              neverbounce: true
            },
            "labelFor": "email",
            "labelName": "Email Address",
            "vmodel": _vm.form.email,
            "formGroupClass": "form-group mb-3",
            "inputType": "email"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "email", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: true,
              digits: 10,
              clearoutPhone: true
            },
            "labelFor": "phone",
            "labelName": "Phone",
            "vmodel": _vm.form.phone,
            "formGroupClass": "form-group mb-3",
            "inputType": "number"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "phone", $event);
            }
          }
        }), _c('div', {
          staticClass: "form-group text-center mb-3 mt-3"
        }, [_c('b-button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(" " + _vm._s(_vm.isCreate ? "Creating..." : "Create") + " ")])], 1)], 1)];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }